import { useMutationRequest } from './chunk-6WWPXI47.mjs';
import { useQueryContext } from './chunk-OYSCTTI3.mjs';
import { useAuthContext } from './chunk-K3UDKV2P.mjs';
import { graphql } from './chunk-NWN55YVG.mjs';
import { __export, __objRest, __spreadProps, __spreadValues } from './chunk-4U7ZT42S.mjs';

// src/listen/mutation-hooks/index.ts
var mutation_hooks_exports = {};
__export(mutation_hooks_exports, {
  useAddAudioToPlaylist: () => useAddAudioToPlaylist,
  useAssignFeeling: () => useAssignFeeling,
  useCreatePlaylist: () => useCreatePlaylist,
  useDeleteAudio: () => useDeleteAudio,
  useDeletePlaylist: () => useDeletePlaylist,
  useRemoveAudioFromPlaylist: () => useRemoveAudioFromPlaylist,
  useReorderPlaylistAudios: () => useReorderPlaylistAudios,
  useUnassignFeeling: () => useUnassignFeeling,
  useUpdateAudio: () => useUpdateAudio,
  useUpdatePlaylist: () => useUpdatePlaylist
});
var LISTEN_SITE = "listen";
var createPlaylistMutation = graphql(
  /* GraphQL */
  `
  mutation CreateListenPlaylist($object: playlist_insert_input!) {
    insert_playlist_one(object: $object) {
      id
      slug
    }
  }
`
);
var updatePlaylistMutation = graphql(
  /* GraphQL */
  `
  mutation UpdatePlaylist($id: uuid!, $set: playlist_set_input!) {
    update_playlist_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
    }
  }
`
);
var deletePlaylistMutation = graphql(
  /* GraphQL */
  `
  mutation DeletePlaylist($id: uuid!) {
    delete_playlist_by_pk(id: $id) {
      id
    }
  }
`
);
var addAudioMutation = graphql(
  /* GraphQL */
  `
  mutation AddAudioToPlaylist($object: playlist_audios_insert_input!) {
    insert_playlist_audios_one(object: $object) {
      playlist_id
      audio_id
      position
    }
  }
`
);
var removeAudioMutation = graphql(
  /* GraphQL */
  `
  mutation RemoveAudioFromPlaylist($playlistId: uuid!, $audioId: uuid!) {
    delete_playlist_audios_by_pk(playlist_id: $playlistId, audio_id: $audioId) {
      playlist_id
      audio_id
    }
  }
`
);
var reorderAudiosMutation = graphql(
  /* GraphQL */
  `
  mutation ReorderPlaylistAudios($updates: [playlist_audios_updates!]!) {
    update_playlist_audios_many(updates: $updates) {
      affected_rows
      returning {
        playlist_id
      }
    }
  }
`
);
var updateAudioMutation = graphql(
  /* GraphQL */
  `
  mutation UpdateAudio($id: uuid!, $set: audios_set_input!) {
    update_audios_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
    }
  }
`
);
var deleteAudioMutation = graphql(
  /* GraphQL */
  `
  mutation DeleteAudio($id: uuid!) {
    delete_audios_by_pk(id: $id) {
      id
    }
  }
`
);
var assignFeelingMutation = graphql(
  /* GraphQL */
  `
  mutation AssignFeeling($object: audio_tags_insert_input!) {
    insert_audio_tags_one(
      object: $object
      on_conflict: { constraint: audio_tags_pkey, update_columns: [] }
    ) {
      audio_id
      tag_id
    }
  }
`
);
var unassignFeelingMutation = graphql(
  /* GraphQL */
  `
  mutation UnassignFeeling($audioId: uuid!, $tagId: uuid!) {
    delete_audio_tags_by_pk(audio_id: $audioId, tag_id: $tagId) {
      audio_id
      tag_id
    }
  }
`
);
var MANAGE_QUERY_KEY = ["listen-manage"];
var HOME_QUERY_KEY = "listen-home";
var useCreatePlaylist = (props = {}) => {
  const { getAccessToken, isSignedIn } = useAuthContext();
  const { invalidateQuery } = useQueryContext();
  const { onSuccess, onError } = props;
  const { mutateAsync } = useMutationRequest({
    document: createPlaylistMutation,
    getAccessToken,
    options: {
      onSuccess: (data) => {
        if (data.insert_playlist_one) {
          invalidateQuery(["listen-playlists", isSignedIn]);
          invalidateQuery(MANAGE_QUERY_KEY);
        }
        onSuccess == null ? void 0 : onSuccess(data);
      },
      onError: (error) => {
        console.error("Create listen playlist failed:", error);
        onError == null ? void 0 : onError(error);
      }
    }
  });
  const createPlaylist = (input) => mutateAsync({ object: __spreadProps(__spreadValues({}, input), { site: LISTEN_SITE }) });
  return createPlaylist;
};
var useUpdatePlaylist = (props = {}) => {
  const { getAccessToken, isSignedIn } = useAuthContext();
  const { invalidateQuery } = useQueryContext();
  const { onSuccess, onError } = props;
  const { mutateAsync } = useMutationRequest({
    document: updatePlaylistMutation,
    getAccessToken,
    options: {
      onSuccess: (data) => {
        const playlist = data.update_playlist_by_pk;
        if (playlist) {
          invalidateQuery(["listen-playlists", isSignedIn]);
          invalidateQuery(MANAGE_QUERY_KEY);
          invalidateQuery(["listen-playlist-detail", isSignedIn, playlist.id]);
        }
        onSuccess == null ? void 0 : onSuccess(data);
      },
      onError: (error) => {
        console.error("Update playlist failed:", error);
        onError == null ? void 0 : onError(error);
      }
    }
  });
  const updatePlaylist = (input) => {
    const _a = input, { id } = _a, fields = __objRest(_a, ["id"]);
    return mutateAsync({ id, set: fields });
  };
  return updatePlaylist;
};
var useDeletePlaylist = (props = {}) => {
  const { getAccessToken, isSignedIn } = useAuthContext();
  const { invalidateQuery } = useQueryContext();
  const { onSuccess, onError } = props;
  const { mutateAsync } = useMutationRequest({
    document: deletePlaylistMutation,
    getAccessToken,
    options: {
      onSuccess: (data) => {
        const playlist = data.delete_playlist_by_pk;
        if (playlist) {
          invalidateQuery(["listen-playlists", isSignedIn]);
          invalidateQuery(MANAGE_QUERY_KEY);
          invalidateQuery(["listen-playlist-detail", isSignedIn, playlist.id]);
        }
        onSuccess == null ? void 0 : onSuccess(data);
      },
      onError: (error) => {
        console.error("Delete playlist failed:", error);
        onError == null ? void 0 : onError(error);
      }
    }
  });
  const deletePlaylist = (id) => mutateAsync({ id });
  return deletePlaylist;
};
var useAddAudioToPlaylist = (props = {}) => {
  const { getAccessToken } = useAuthContext();
  const { invalidateQuery } = useQueryContext();
  const { onSuccess, onError } = props;
  const { mutateAsync } = useMutationRequest({
    document: addAudioMutation,
    getAccessToken,
    options: {
      onSuccess: (data) => {
        var _a;
        const playlistId = (_a = data.insert_playlist_audios_one) == null ? void 0 : _a.playlist_id;
        if (playlistId) {
          invalidateQuery(["listen-playlist-detail", playlistId]);
        }
        onSuccess == null ? void 0 : onSuccess(data);
      },
      onError: (error) => {
        console.error("Add audio to playlist failed:", error);
        onError == null ? void 0 : onError(error);
      }
    }
  });
  const addAudio = (input) => mutateAsync({
    object: {
      playlist_id: input.playlistId,
      audio_id: input.audioId,
      position: input.position
    }
  });
  return addAudio;
};
var useRemoveAudioFromPlaylist = (props = {}) => {
  const { getAccessToken } = useAuthContext();
  const { invalidateQuery } = useQueryContext();
  const { onSuccess, onError } = props;
  const { mutateAsync } = useMutationRequest({
    document: removeAudioMutation,
    getAccessToken,
    options: {
      onSuccess: (data) => {
        var _a;
        const playlistId = (_a = data.delete_playlist_audios_by_pk) == null ? void 0 : _a.playlist_id;
        if (playlistId) {
          invalidateQuery(["listen-playlist-detail", playlistId]);
        }
        onSuccess == null ? void 0 : onSuccess(data);
      },
      onError: (error) => {
        console.error("Remove audio from playlist failed:", error);
        onError == null ? void 0 : onError(error);
      }
    }
  });
  const removeAudio = (input) => mutateAsync({ playlistId: input.playlistId, audioId: input.audioId });
  return removeAudio;
};
var useReorderPlaylistAudios = (props = {}) => {
  const { getAccessToken } = useAuthContext();
  const { invalidateQuery } = useQueryContext();
  const { onSuccess, onError } = props;
  const { mutateAsync } = useMutationRequest({
    document: reorderAudiosMutation,
    getAccessToken,
    options: {
      onSuccess: (data) => {
        var _a;
        const playlistIds = new Set(
          (_a = data.update_playlist_audios_many) == null ? void 0 : _a.flatMap(
            (result) => {
              var _a2;
              return (_a2 = result == null ? void 0 : result.returning.map((row) => row.playlist_id)) != null ? _a2 : [];
            }
          )
        );
        for (const playlistId of playlistIds) {
          invalidateQuery(["listen-playlist-detail", playlistId]);
        }
        onSuccess == null ? void 0 : onSuccess(data);
      },
      onError: (error) => {
        console.error("Reorder playlist audios failed:", error);
        onError == null ? void 0 : onError(error);
      }
    }
  });
  const reorderAudios = (updates) => mutateAsync({
    updates: updates.map((update) => ({
      where: {
        playlist_id: { _eq: update.playlistId },
        audio_id: { _eq: update.audioId }
      },
      _set: { position: update.position }
    }))
  });
  return reorderAudios;
};
var useUpdateAudio = (props = {}) => {
  const { getAccessToken, isSignedIn } = useAuthContext();
  const { invalidateQuery } = useQueryContext();
  const { onSuccess, onError } = props;
  const { mutateAsync } = useMutationRequest({
    document: updateAudioMutation,
    getAccessToken,
    options: {
      onSuccess: (data) => {
        if (data.update_audios_by_pk) {
          invalidateQuery(MANAGE_QUERY_KEY);
          invalidateQuery([HOME_QUERY_KEY, isSignedIn]);
        }
        onSuccess == null ? void 0 : onSuccess(data);
      },
      onError: (error) => {
        console.error("Update audio failed:", error);
        onError == null ? void 0 : onError(error);
      }
    }
  });
  const updateAudio = (input) => {
    const _a = input, { id } = _a, fields = __objRest(_a, ["id"]);
    return mutateAsync({ id, set: fields });
  };
  return updateAudio;
};
var useDeleteAudio = (props = {}) => {
  const { getAccessToken, isSignedIn } = useAuthContext();
  const { invalidateQuery } = useQueryContext();
  const { onSuccess, onError } = props;
  const { mutateAsync } = useMutationRequest({
    document: deleteAudioMutation,
    getAccessToken,
    options: {
      onSuccess: (data) => {
        if (data.delete_audios_by_pk) {
          invalidateQuery(MANAGE_QUERY_KEY);
          invalidateQuery([HOME_QUERY_KEY, isSignedIn]);
        }
        onSuccess == null ? void 0 : onSuccess(data);
      },
      onError: (error) => {
        console.error("Delete audio failed:", error);
        onError == null ? void 0 : onError(error);
      }
    }
  });
  const deleteAudio = (id) => mutateAsync({ id });
  return deleteAudio;
};
var useAssignFeeling = (props = {}) => {
  const { getAccessToken, isSignedIn } = useAuthContext();
  const { invalidateQuery } = useQueryContext();
  const { onSuccess, onError } = props;
  const { mutateAsync } = useMutationRequest({
    document: assignFeelingMutation,
    getAccessToken,
    options: {
      onSuccess: (data) => {
        if (data.insert_audio_tags_one) {
          invalidateQuery(MANAGE_QUERY_KEY);
          invalidateQuery([HOME_QUERY_KEY, isSignedIn]);
        }
        onSuccess == null ? void 0 : onSuccess(data);
      },
      onError: (error) => {
        console.error("Assign feeling failed:", error);
        onError == null ? void 0 : onError(error);
      }
    }
  });
  const assignFeeling = (input) => mutateAsync({ object: { audio_id: input.audioId, tag_id: input.tagId } });
  return assignFeeling;
};
var useUnassignFeeling = (props = {}) => {
  const { getAccessToken, isSignedIn } = useAuthContext();
  const { invalidateQuery } = useQueryContext();
  const { onSuccess, onError } = props;
  const { mutateAsync } = useMutationRequest({
    document: unassignFeelingMutation,
    getAccessToken,
    options: {
      onSuccess: (data) => {
        if (data.delete_audio_tags_by_pk) {
          invalidateQuery(MANAGE_QUERY_KEY);
          invalidateQuery([HOME_QUERY_KEY, isSignedIn]);
        }
        onSuccess == null ? void 0 : onSuccess(data);
      },
      onError: (error) => {
        console.error("Unassign feeling failed:", error);
        onError == null ? void 0 : onError(error);
      }
    }
  });
  const unassignFeeling = (input) => mutateAsync({ audioId: input.audioId, tagId: input.tagId });
  return unassignFeeling;
};

export { mutation_hooks_exports, useAddAudioToPlaylist, useAssignFeeling, useCreatePlaylist, useDeleteAudio, useDeletePlaylist, useRemoveAudioFromPlaylist, useReorderPlaylistAudios, useUnassignFeeling, useUpdateAudio, useUpdatePlaylist };
//# sourceMappingURL=chunk-WGNXOL3J.mjs.map
//# sourceMappingURL=chunk-WGNXOL3J.mjs.map